(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bt-xmas-wrapping"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-wrapping-marquee')) {
    customElements.define('bt-wrapping-marquee', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const button = this.querySelector('.bt-wrapping__toggle');
        if (!button) return;
        this.initialized = true;
        button.addEventListener('click', () => {
          const paused = this.classList.toggle('bt-wrapping--paused');
          button.setAttribute('aria-pressed', String(paused));
          button.setAttribute('aria-label', paused ? button.dataset.resume : button.dataset.pause);
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["porta-new-arrivals"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('bt-new-arrivals')) {
    customElements.define('bt-new-arrivals', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.bt-arrivals__track');
        this.controls = this.querySelector('.bt-arrivals__controls');
        this.buttons = this.querySelectorAll('.bt-arrivals__arrow');
        this.abort = new AbortController();
        const update = () => {
          const end = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = end < 2;
          this.buttons[0].disabled = this.track.scrollLeft < 2;
          this.buttons[1].disabled = this.track.scrollLeft >= end - 2;
        };
        this.buttons.forEach(button => button.addEventListener('click', () => {
          const step = this.track.firstElementChild.getBoundingClientRect().width + 6;
          const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          this.track.scrollBy({ left: step * Number(button.dataset.direction), behavior: reduced ? 'instant' : 'smooth' });
        }, { signal: this.abort.signal }));
        this.track.addEventListener('scroll', update, { passive: true, signal: this.abort.signal });
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.observer?.disconnect();
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
